import { LANGUAGE_DOMESTIC, LANGUAGE_FOREIGN, LANGUAGE_NAME } from 'src/constants/ActionTypes';
import { IStateLanguage } from 'src/entity/StateEntity';

const initialState: IStateLanguage = {
  type: LANGUAGE_DOMESTIC,
  language: 'zh-hans',
};

export const languageState = (state: IStateLanguage = initialState, action: IStateLanguage): IStateLanguage => {
  switch (action.type) {
    case LANGUAGE_DOMESTIC:
      return Object.assign({}, state, {
        type: action.type,
      });
    case LANGUAGE_FOREIGN:
      return Object.assign({}, state, {
        type: action.type,
      });
    case LANGUAGE_NAME:
      return Object.assign({}, state, {
        language: action.language,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/languageState.ts